import React = require('react');

import l10n from 'diy/util/l10n';

interface StartViewProps {
    url: string;
}

export default class StartView extends React.Component<StartViewProps, any> {
    render() {
        let dialogSubtitle = l10n('migration.dialog.subtitle');
        let dialogContent = l10n('migration.dialog.content');

        if (typeof this.props.url !== 'undefined' && this.props.url !== '') {
            dialogContent = dialogContent.replace(
                "{link}",
                `<a href=${this.props.url} target="_blank">
                     ${this.props.url}
                 </a>`
            );
        }

        return (
            <div>
                <h3>{l10n('migration.dialog.title')}</h3>
                <p className="subtitle">
                    <span dangerouslySetInnerHTML={{__html: dialogSubtitle}} />
                </p>
                <p className="content">
                    <span dangerouslySetInnerHTML={{__html: dialogContent}} />
                </p>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/externalwebsiteimport/startDialog/views/StartView.tsx
 **/